export default "__VITE_ASSET__6f853d6e__"